module.exports = __webpack_public_path__ + "static/frame-mock.7943d425.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/tst/frame-mock.png
// module id = 1208
// module chunks = 39732927749384